import {createApp} from "vue";
import VeeValidate from "vee-validate";
import vSelect from 'vue-select'
import './less/elements/vue-select-custom.less';
import IndexPage from "@/components/IndexPage.vue";
import ContactPage from "@/components/ContactPage.vue";
import LifetimeAwardPage from "@/components/LifetimeAwardPage.vue";
import AwardsPage from "@/components/AwardsPage.vue";
import ReferencesPage from "@/components/ReferencesPage.vue";
import VueEasyLightbox from "vue-easy-lightbox";


createNewApp("app", IndexPage)
createNewApp("contact", ContactPage)
createNewApp("awards", AwardsPage)
createNewApp("LifetimeAwardPage", LifetimeAwardPage)
createNewApp("references", ReferencesPage)


function createNewApp(appId, pageName) {
    if (getElement(appId)) {
        const app = createApp(pageName);
        // @ts-ignore
        app.use(VeeValidate);
        app.use(VueEasyLightbox);
        app.component('v-select', vSelect)
        app.mount("#" + appId);
    }
}

function getElement(id) {
    return document.getElementById(id) != null ? true : false
}
